import React from "react";
import { Link } from "react-router-dom";

export const PublicFooter = () => (
  <footer className="border-t bg-background py-10 mt-12" data-testid="public-footer">
    <div className="max-w-6xl mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Brand */}
        <div className="text-sm text-muted-foreground md:col-span-1">
          <p className="font-semibold text-base mb-1">Biz360 ❤️‍🔥</p>
          <p className="leading-relaxed">L'outil de pilotage des auto-entrepreneurs français.</p>
          <p className="mt-3 text-xs">
            Édité par Tiphaine SAMBLAT
            <br />
            SIREN 913 345 682
          </p>
        </div>

        {/* Compliance légale */}
        <div className="text-sm">
          <p className="font-semibold mb-3" style={{ color: "#210875" }}>Légal</p>
          <ul className="space-y-2">
            <li>
              <Link
                to="/mentions-legales-cgu"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-mentions-link"
              >
                Mentions légales
              </Link>
            </li>
            <li>
              <Link
                to="/mentions-legales-cgu#cgu"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-cgu-link"
              >
                CGU
              </Link>
            </li>
            <li>
              <Link
                to="/cgv"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-cgv-link"
              >
                CGV
              </Link>
            </li>
            <li>
              <Link
                to="/politique-confidentialite"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-privacy-link"
              >
                Politique de confidentialité
              </Link>
            </li>
            <li>
              <Link
                to="/retractation"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-retractation-link"
              >
                Rétractation
              </Link>
            </li>
          </ul>
        </div>

        {/* Comprendre le statut */}
        <div className="text-sm">
          <p className="font-semibold mb-3" style={{ color: "#210875" }}>Le statut AE</p>
          <ul className="space-y-2">
            <li>
              <Link
                to="/statut-auto-entrepreneur"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-statut-link"
              >
                L'essentiel du statut
              </Link>
            </li>
            <li>
              <Link
                to="/statut-auto-entrepreneur#cotisations"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-cotisations-link"
              >
                Cotisations sociales
              </Link>
            </li>
            <li>
              <Link
                to="/statut-auto-entrepreneur#droit-travail"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-droit-travail-link"
              >
                Droit du travail
              </Link>
            </li>
            <li>
              <a
                href="https://www.autoentrepreneur.urssaf.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-urssaf-official-link"
              >
                Site officiel Urssaf ↗
              </a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="text-sm">
          <p className="font-semibold mb-3" style={{ color: "#210875" }}>Contact</p>
          <ul className="space-y-2">
            <li>
              <a
                href="mailto:t.samblat@gmail.com"
                className="text-muted-foreground hover:text-foreground"
                data-testid="footer-contact-link"
              >
                t.samblat@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 pt-4 border-t text-xs text-center text-muted-foreground">
        © 2026 Biz360 — Tous droits réservés. Service en langue française.
      </div>
    </div>
  </footer>
);

export default PublicFooter;
